/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum PlanFamily {
  PRO = 'pro',
  MAX = 'max',
  BUSINESS = 'business',
  CREDIT = 'credit',
  UNDEFINED = 'undefined',
}
